/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': '该账号未注册，请先前往注册后再登录	',
    'no_zone_code': '(无需区号)',
    '授权校验失败，请刷新页面并重试。': '授权校验失败，请刷新页面并重试',
    'onlineService': '在<br/>线<br/>客<br/>服',
    'eParcel': 'KEX小包',
    'overseasFulfilment': 'KEX电商专递',
    'warehouse': '海外仓',
    'standardExpress': 'KEX标快',
    'economyExpress': 'KEX特惠',
    'heavyFreight': 'KEX重货',
    'pleaseAgreePolicy': '请先阅读并同意《隐私政策》',
    'pleaseAgreeToScan': '请先阅读并同意右侧协议',
    '验证码接收方式': '验证码接收方式',
    'cancelTips': '您的账号还未绑定手机号或邮箱，请先前往绑定后才能通过身份认证做注销操做。',
    'confirmCancel': '确认注销',
    'verificationCodeError': '验证码错误，请重新获取验证码!',
    'clickGoDirectly': '(点击直接前往)',
    'repeatTips': '您的账号存在重复问题，请前往<span class="mode">选择登录方式</span>后登录，{count}秒后自动跳转',
    'repeatTips1': '您的手机号存在重复问题，请前往<span class="mode">选择区号</span>后登录，{count}秒后自动跳转',
    'goOldLogin': '旧版登录',
    'goNewLogin': '新版登录',
    'siteTips': '为获得更好的系统使用体验，您可以选择切换到另一个国家或地区',
    'siteGo': '前往',
    'loginLoading': '账号自动登录新系统，请稍候',
    'sfExpress': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': 'KEX认证服务中心',
    'jumpError': '跳转地址不合法',
    'tips': '提示',
    'tips1': '温馨提示',
    'confirm': '确认',
    'agreeAndContinue': '我已阅读并同意《隐私政策》',
    'agreeService': '我已阅读并同意《服务条款》',
    'agreeUserAgreement': '我已阅读并同意《用户协议》',
    'define': '确定',
    'cancel': '取消',
    'yes': '是',
    'no': '否',
    'sendAgain': '重新发送',
    'second': ' 秒',
    'iknow': '我知道了',
    'country': '国家/地区',
    'tel': '手机号',
    'email': '邮箱',
    'telNumber': '手机号码',
    'verifyCode': '验证码',
    'sendVerificationCode': '发送验证码',
    'next': '下一步',
    'prev': '上一步',
    'finished': '完成',
    'back': '返回',
    'backLogin': '返回登录',
    'home': 'ABX官网',
    'home_os': 'ABX Express',
    'inquiry': '查询',
    'add': '新增',
    'edit': '编辑',
    'del': '删除',
    'batchDel': '批量删除',
    'operating': '操作',
    'clearInfo': '清空信息',
    'excelUpload': 'Excel上传',
    'serialNumber': '序号',
    'save': '保存',
    'leastOne': '请先勾选要删除的数据',
    'uploadFile': '上传文件',
    'downloadExcel': '下载EXCEL模板',
    'pleaseInput': '请输入',
    'pleaseSelect': '请选择',
    'isDel': '确定删除选择的数据吗？',
    'agree': '同意',
    'disagree': '不同意',
    'uploadTotal': '上传总数',
    'uploadSuccess': '上传成功',
    'uploadFail': '上传失败',
    'checkAll': '全选',
    'cancelContent': '该账号于[{cancelTime}]提交注销，15天内登录则重新激活，是否继续登录？',
    'ok': '好的', // V1.5
    'autoTip': '正在鉴权中，请等待...',
    'feedback': '功能反馈/建议',
    'scanCode': '扫码登录',
    'useWxScan': '使用微信扫一扫',
    'useWhatsAppScan': '使用WhatsApp扫一扫',
    'otherLoginWays': '其他登录方式',
    'scanSuccessfully': '扫码成功',
    'confirmOnPhone': '请在手机上确认',
    'refreshQR': '点击刷新',
    'consult': '合作咨询',
    'please_select_correct_phone': '请选择正确手机区号',
    '国际标快': '国际标快',
    '国际特惠': '国际特惠',
    '顺丰集运': '顺丰集运',
    '国际电商专递': '国际电商专递',
    '国际小包': '国际小包',
    '海外仓': '海外仓',
    '顺丰国际产品导航': '产品导航'
  },
  'channel': {
    'gls': 'GLS 海外联盟',
    'gls_tooltip': '请在邮件正文填写登录账号，邮件主题【GLS忘记密码】，发送邮件至wuzipeng@sf-express.com'
  },
  'login': {
    'toLogin': '去登录',
    'account': '账号',
    'accountRepeativeTitle': '账号重复处理',
    'accountRepeativeDesc': '您的账号存在重复，需要您确认将以哪一个账号登录系统，您也可以选择登录后注销或重新绑定其中一个账号，避免后续再次出现同类情况。',
    'accountType': '账号类型',
    'aciton': '操作',
    'merge': '三要素融合版',
    'unique': '三要素独立版',
    'selectLoginType': '选择登录方式',
    'personal': '个人登录',
    'enterprise': '企业登录',
    'tel': '手机号',
    'password': '密码',
    'verificationCodeLogin': '验证码登录',
    'verificationCode': '验证码',
    'obtainVerificationCode': '获取验证码',
    'passwordLogin': '密码登录',
    'rememberPSD': '记住我',
    'rememberTips': '不推荐在公共设备上选择',
    'forgetPSD': '忘记密码',
    'loginAgree': '我已阅读并同意',
    'agreeTips': '《隐私政策》',
    'userAgreement': '《用户协议》',
    'login': '登录',
    'username': '用户名',
    'email': '邮箱',
    'phoneLogin': '手机号登录',
    'usernameLogin': '用户名登录',
    'emailLogin': '邮箱登录',
    'usernameOrEmailLogin': '用户名/邮箱登录',
    'registerNow': '立即注册',
    'pleaseInput': '请输入',
    'and': '和',
    'sfbuy_privacy': '《集运服务协议》',
    'sfbuy_title': '集运',
    'aboutUs': '关于我们',
    'serviceGuide': '新手指南',
    'helpCenter': '帮助中心',
    'serviceAndPrice': '服务与价格',
    'onlineCSR': '在线客服',
    'copyright': 'Copyright ©2023 ABX 版权所有',
    applyCustomer: '新客引入'
  },
  'register': {
    'personal': '个人用户注册',
    'enterprise': '企业用户注册',
    'tel': '手机号',
    'telVerificationCode': '手机验证码',
    'email': '邮箱',
    'emailVerificationCode': '请输入邮箱验证码',
    'sendVerificationCode': '发送验证码',
    'password': '输入密码',
    'passwordAgain': '再次输入新密码',
    'agree': '我已同意',
    'termsOfService': '《服务条款》',
    'SFBuyService': '《顺丰集运服务协议》',
    'and': '和',
    'privacyPolicy': '《隐私政策》',
    'registerNow': '立即注册',
    'haveUserName': '已有账号？',
    'loginNow': '立即登录',
    'toEmail': '邮箱注册',
    'toTel': '手机注册',
    'invitationCode': '请输入注册/贵宾邀请码',
    'timeCount': '（剩余{count}s，请阅读至末尾）',
    'readBottom': '（请阅读至末尾）',
    'isFinshRead': '请阅读并同意条款信息'
  },
  'resetPassword': {
    'resetTel': '手机重置',
    'resetEmail': '邮箱重置',
    'tel': '手机号',
    'telVerificationCode': '手机验证码',
    'email': '邮箱',
    'emailVerificationCode': '邮箱验证码',
    'sendVerificationCode': '发送验证码',
    'newPassword': '新密码',
    'confirmNewPassword': '确认新密码',
    'resetPassword': '重置密码',
    'back': '返回',
    'login': '登录',
    'register': '注册',
  },
  'modifyPassword': {
    'changePassword': '修改密码',
    'old': '旧密码',
    'new': '新密码',
    'confirm': '确认新密码',
  },
  'cookies': {
    // v1.4.sp4开始
    'tip1': '我们的网站使用cookie来优化用户体验和分析。我们可能会与我们的分析合作伙伴共享您的信息。我们的',
    'tip2': '《Cookie政策》',
    'tip3': '提供更多的信息。如需更改您的设置，请点击',
    'tip4': '这里',
    'tip5': '。点击同意，即表示您同意我们根据您的偏好使用cookies。',
    'disAgree': '拒绝',
    'cookieSet': 'Cookie设置',
    'preference': '偏好类',
    'optimisation': '优化类',
    'analytics': '分析类',
    'neddCheck': '必须先勾选偏好类',
    // v1.4.sp4结束
    'cookie': 'Cookie政策',
    'agree': '同意',
    'preferenceCenter': '偏好中心', // V1.6
  },
  'slideCircus': {
    'title': '账户信息确认',
    'change': '换一换',
    'right': '请按住滑块向右拖动完成拼图',
    'pass': '验证通过',
    'verifyText': '请点击按钮进行验证',
    'verifying': '拼图验证中...',
    'loading': '图片加载中',
  },
  'message': {
    'slideError': '滑块服务调用失败',
    'selectTerms': '请查看并勾选条款信息',
    'verifyPass': '请点击按钮进行验证',
    'registerSuccess': '注册成功',
    'sendTips0': '发送成功',
    'resetPasswordTips0': '密码重置成功',
    'loginTips0': '登录成功',
    'loginTips1': '登录成功，账号已激活',
    'modifiedTips0': '修改成功',
    'switchLanguage': '成功切换语言',
    'switchSite': '成功切换国家',
    'changeTel': '恭喜您，您的手机修改成功，请重新登录！',
    'ChangeEmail': '恭喜您，您的邮箱修改成功，请重新登录！',
    'cancelSuccess': '恭喜您，您的账号注销成功！',
    'imgType': '请重新选择图片，图片仅支持上传JPG和PNG格式！',
    'imgSize': '请重新选择图片，图片大小不能超过3MB！',
    'submitSuccess': '提交成功',
    'setSuccess': '设置成功',
    'delSuccess': '删除成功',
    'addSuccess': '新增成功',
    'fileType': '请重新选择文件，文件仅支持xls、xlsx的格式！',
    'fileSize': '请重新选择文件，文件大小不能超过15MB！',
    'delError': '删除失败，请稍后重试',
    'uploadFile': '请上传文件',
    'uploadFileSuccess': '上传成功',
    'selectedOne': '清关资料或出生日期至少填写一种',
    'imgTips1': '请上传{imgType}格式的图片',
    'imgTips2': '单张图片不能超过3MB',
    'imgTips3': '单张图片不能超过10MB',
    'imgTips4': '暂不支持PDF文件预览',
    'checkProduct': '请选择产品',
    'clauseAgree': '请同意《电子运单契约条款》',
    'estimatedCost': '请在附加服务表格输入预估费用',
    'cardCode': '请在附加服务表格输入代收货款卡号',
    'threeTips': '物品信息填写不完善，请重新检查',
    'fourTips': '下单信息填写不完善，请重新检查',
    'noNeedUpload': '无需上传证件',
    'phoneOrFixAtLeastOne': '手机号、固定电话请至少填写一个',
    'customerOrderNo': '请输入客户订单号', // V1.5
    'mas_003038': '您的登录账号出现异常，请刷新页面再尝试下单。',
    'mas_003038_HTM': '您登录（手机号码）出现异常，请刷新页面再尝试下单。',
    'mas_003035': '您的账号已经注冊過，请直接从IUOP登入下KEX件单。',
    'mas_auth_failed': '鉴权失败',
  },
  'verify': {
    'selectAreaCode': '请选择国家/区号',
    'telTips': '请输入手机号',
    'telError': '请输入正确的手机号',
    'companyNameTrue': '请输入正确的公司名称',
    'fixMobileCode': '请选择固定电话区号',
    'fixMobileNumber': '请输入固定电话号码',
    'fixMobileNumberReg': '请输入正确的固定电话号码',
    'mobileVerificationCode': '请输入手机验证码',
    'emailAddress': '请输入邮箱',
    'emailTips': '请输入正确的邮箱',
    'emailVerificationCode': '请输入邮箱验证码',
    'password': '请输入密码',
    'passwordError': '密码为8-20位，仅支持大小写字母、数字和符号3种及以上的组合',
    'passwordAgain': '请再次输入密码',
    'passwordNotSame': '两次输入密码不一致',
    'usernameTips': '请输入用户名',
    'usernameEmailTips': '请输入用户名/邮箱',
    'telEmailTips': '请输入手机号(无需区号)/邮箱',
    'fixTelEmailTips': '请输入正确的手机号(无需区号)/邮箱',
    'selectTerms': '请查看并勾选条款信息',
    'accountName': '支持以字母开头,可包含字母、数字及下划线的6-20个字符',
    'verifyType': '请选择验证方式',
    'verifyCode': '请输入验证码',
    'lastNameRequired': '姓氏不能为空',
    'firstNameRequired': '名字不能为空',
    'genderRequired': '性别不能为空',
    'birthdayRequired': '生日不能为空',
    'certTypeRequired': '证件类型不能为空',
    'certNoRequired': '证件号不能为空',
    'certExpireDateRequired': '证件有效期不能为空',
    'notSupTips': '不支持数字和其他特殊字符',
    'certImage': '请上传证件图片后再提交',
    'commodityName': '请输入托寄物品名称',
    'quantity': '请输入数量',
    'unit': '请选择单位',
    'unitPrice': '请输入单价',
    'placeOfOrigin': '请选择原产地',
    'over0': '请输入大于0的数字',
    'decimal3': '只支持小数点后3位',
    'decimal6': '只支持小数点后6位',
    'decimal10': '只支持小数点后10位',
    'productRecordNo': '请输入正确的国检备案号',
    'hsCode': '请输入正确的海关编码',
    'productCustomsNo': '请输入正确的海关备案号',
    'contact': '请输入姓名',
    'companyName': '请输入公司名称',
    'country': '请选择国家/地区',
    'regionFirst': '请选择省市区',
    'roadName': '请输入道路名',
    'buildingNumber': '请输入建筑编号',
    'addressDetail': '请输入详细地址',
    'addressDetailTrue': '请输入正确的详细地址',
    'postalCode': '请输入邮编',
    'phoneNumber': '请输入手机号码',
    'numberDecimal': '请输入数字',
    'bangmecho': '请输入番目町',
    'shippingType': '请选择寄件类型',
    'clearanceInfo': '请选择证件类型',
    'idNumber': '请输入证件号码',
    'idNumberIsTrue': '请输入正确的证件号码',
    'contactCn': '请输入正确的中文名',
    'receiveType': '请选择收件类型',
    'imgNumber': '至少上传{number}张图片',
    'papersTime': '请选择证件有效时间',
    'declaredCurrency': '请选择币种',
    'requred': '此字段必填',
    'parcelTotalWeight': '请输入总重量',
    'contentMaxLength18': '内容长度在1和18之间',
    'contentIntOrFloatMaxLength': '最多支持12位整数，10位小数',
    'atLeastSelectTip': '请至少选中一条记录',
    'invitationCode': '请输入正确的邀请码',
    'characterLength': '长度不超过{length}字符',
    'pickUpTime': '请选择预约上门取件时间',
    'onlyNumberAndLetter': '仅支持数字字母组合',
    'serviceFee': '附加服务的预估费用最多支持12位整数，2位小数',
    'methoedCode': '附加服务的代收货款卡号最多支持20位数字',
    'contentInt14OrFloat2MaxLength': '最多支持14位整数，2位小数',
    'contentInt10OrFloat6MaxLength': '最多支持10位整数，6位小数',
    'contentInt18OrFloat6MaxLength': '最多支持18位整数，6位小数',
    'timeZoneCode': '请选择时区',
    'contentInt14OrFloat1MaxLength': '最多支持14位整数，1位小数',
    'contentInt15OrFloat5MaxLength': '最多支持15位整数，5位小数',
  },
  'placeholder': {
    'countryCode': '请选择国家/区号',
    'telCode': '区号',
    'phoneCode': '请输入手机号',
    'mobileVerificationCode': '请输入手机验证码',
    'verificationCode': '请输入验证码',
    'emailAddress': '请输入邮箱',
    'emailVerificationCode': '请输入邮箱验证码',
    'password': '请输入密码',
    'checkPassword': '请再次输入密码',
    'enter': '请输入',
    'username': '用户名可用于登录',
    'cardType': '请选择证件类型',
    'uploadCard': '与证件信息保持一致',
    'uploadCardId': '请输入有效的证件号码',
    'passwordError': '密码为8-20位，仅支持大小写字母、数字和符号2种及以上的组合',
    'passwordAgain': '再次输入新密码',
    'verifyType': '请选择验证方式',
    'newEmail': '请输入您常用的邮箱地址',
    'addressBook': '请输入姓名/公司名称查询',
    'goodsWarehouse': '请输入托寄物品名称/海关编码查询',
    'clearanceWaybill': '请输入12位数字运单号或\'SF\'开头的15位运单号',
    'parcelTotalLength': '请输入长',
    'parcelTotalWidth': '请输入宽',
    'parcelTotalHeight': '请输入高',
    'senderReason': '请选择寄件原因',
    'tradeCondition': '请选择贸易条件',
    'senderReasonContent': '请填写非商业寄件原因',
    'businessRemark': '请填写商业发票备注',
    'pickupAppointTime': '选择日期时间（取件时间在您预约3小时内）',
    'remarkText': '可手动输入文字',
    'payMethod': '请选择付款方式',
    'payMonthCard': '请输入月结账号',
    'taxPayMethod': '请选择税金付款方式',
    'taxPayMonthCard': '请输入税金结算账号',
    'serviceFee': '请输入预估费用',
    'feeCard': '请输入代收货款卡号',
    'invitationCode': '请输入注册/贵宾邀请码',
    'willBay': '请输入运单号',
    'senderCountry': '请选择原寄地',
    'receiverCountry': '请选择目的地',
    'receiverContact': '请输入收件人姓名',
    'orderStatus': '请选择订单状态',
    'startTime': '开始日期',
    'to': '至',
    'endTime': '结束日期',
    'timeZoneCode': '请选择时区',
  },
  'tagsView': {
    'refresh': '刷新',
    'close': '关闭',
    'closeOthers': '关闭其它',
    'closeAll': '关闭所有',
  },
  'exit': {
    'title': '退出登录',
    'message': '确认退出？',
    'success': '退出成功！',
    'cancel': '取消退出！',
    'close': '注销成功',
  },
  'notFind': {
    'oops': '404',
    'info': '抱歉，您访问的页面不存在',
    'backHome': '返回主页',
  },
  'settings': {
    'title': 'ABX认证服务中心',
  },
  'role': {
    'admin': '管理员',
    'user': '普通用户',
  },
  'route': {
    'Login': '登录',
    '顺丰国际产品导航': '产品导航',
    'Register': '注册',
    'ResetPassword': '找回密码',
    'UserCenter': '个人中心',
    'MyInfomation': '我的资料',
    'AccountInfomation': '账号信息',
    'BaseInfomation': '基本信息',
    'AccountSecurity': '账号安全',
    'ProtocolManage': '签署管理',
    'BindingEmail': '绑定邮箱',
    'BindingPhone': '绑定手机',
    'CancelAccount': '注销账号',
    'ChangeEmail': '修改邮箱',
    'ChangePassword': '修改密码',
    'ChangePhone': '修改手机',
    'Name': '设置用户名',
    'ToMail': '我要寄件',
    'MailProduct': '寄件产品',
    'AddressBook': '地址簿',
    'GoodsWarehouse': '物品库',
    'Order': '订单管理',
    'OrderIndex': '订单列表',
    'OrderAdd': '单票下单',
    'Clearance': '清关资料',
    'UploadPhotoid': '证件上传',
    'EditOrder': '订单编辑',
    'permission': '权限管理', // v1.2
    'permission_system': '系统管理', // v1.2
    'permission_role': '角色管理', // v1.2
    'permission_resource': '资源权限', // v1.2
    'permission_user': '用户管理', // v1.2
  },
  'button': {
    'sumbit': '提交',
  },
  'accountInfo': {
    'username': '用户名称：',
    'firstname': '名字：',
    'lastname': '姓氏：',
    'sex': '性别：',
    'man': '男',
    'woman': '女',
    'telNumber': '手机号码：',
    'telNumberNot': '您的账号还没有绑定手机号码',
    'email': '邮箱：',
    'emailNot': '您的账号还没有绑定邮箱',
    'binding': '立即绑定 > ',
    'changeTel': '修改手机 > ',
    'changeEmail': '修改邮箱 > ',
    'validated': '已验证',
    'autoGeneration': '自动生成',
    'usernameTips': '用户名设置之后不能修改',
    'birthday': '出生日期：',
    'birthday1': '出生日期',
    'autoCreate': '自动生成',
  },
  'baseInfo': {
    'cardType': '证件类型：',
    'firstname': '名字：',
    'lastname': '姓氏：',
    'cardId': '证件号码：',
    'cardTime': '证件有效期：',
    'cardImg': '证件图片：',
    'cardLangTime': '永久有效',
    'uploadImg': '上传图片',
    'titleTips': '温馨提示：国家实行寄件实名制，并用于海关清关，证件信息将设置清关专用水印，KEX将保证您的信息安全。',
    'dialogTitle': '标准示例',
    'dialogTips': '上传的身份证照片四角完整，文字清晰，无反光遮挡，如果模糊，太暗，可能会认证失败！',
    'cardUp': '证件正面',
    'cardDown': '证件反面',
  },
  'emailLink': {
    'tips': '请设置账号密码',
    'setPassword': '设置密码',
    'success': '账号已激活成功',
  },
  'accountSecurity': {
    'ChangePassword': '修改密码',
    'ChangePasswordDesc': '若长时间未登录导致密码忘记，可验证身份后，修改密码。',
    'BindingPhone': '绑定手机',
    'BindingPhoneDesc': '绑定手机可用于手机登录、找回密码、下单等服务。',
    'BindingEmail': '绑定邮箱',
    'BindingEmailDesc': '绑定邮箱可用于邮箱登录、找回密码、下单等服务。',
    // V1.2开始
    'SettingName': '设置用户名',
    'SettingNameDesc': '用户名可作为登录账号，设置之后不可修改',
    'firstname': '名(first name)',
    'lastname': '姓(last name)',
    'SettingRealName': '设置姓名(First name & Last name)	',
    'SettingRealNameDesc': '设置个人姓名信息，作为账号属性存在，可多次编辑。	',
    'immediatelySet': '立即设置',
    'alreadySet': '已设置',
    'settingComplete': '设置完成',
    'alreadyBinding': '已绑定',
    'userName': '用户名称',
    'userNameLogin': '用户名可用于登录',
    'selfCreate': '自动生成',
    'stopEdit': '用户名设置之后不能再修改',
    'setOk': '设置完成',
    // V1.2结束
    //  V1.3.SP3 账号注销开始
    'cancelAccount': '账号注销',
    'cancelAccountTips': '注销后数据无法恢复，请谨慎操作',
    'toCancel': '立即注销',
    'cancelToKnow': '账号注销协议',
    'cancelDesc1': '1、一旦申请注销，被注销后的账号将无法使用和恢复，请您谨慎操作，在操作之前自行备份账户相关的所有信息和数据；',
    'cancelDesc2': '2、申请注销即表示您自愿放弃账号内所有会员权益和虚拟资产（包括但不限于会员积分、会员等级及会员权益、优惠券等）；',
    'cancelDesc3': '3、注销后，您将无法再登录、使用本账号，也将无法找回您账号中及与账号相关的任何内容或信息，包括但不限于：用户名、头像等（运单信息将按照隐私政策约定的时限保存，您可通过运单号在ABX官网查询货件路由信息）；',
    'cancelDesc4': '4、如您已开通月结账号，注销后，本账号与您的月结账户绑定关系将解除，如需继续使用月结账号，需重新绑定新的账号；',
    'cancelDesc5': '5、注销本账号并不代表本账号注销前的账号行为和相关责任得到豁免或减轻；',
    'cancelDesc6': '6、本注销申请可在15天内取消，自注销之日起15天内，用户可通过重新登录取消账号注销申请。',
    'cancelAgree': '我已阅读并同意《账号注销协议》',
    'cancelTitle': '注销账号',
    'cancelConfirm': '是否确定立即注销账号？',
    'goBinding': '立即绑定',
    'changeBinding': '立即换绑',
    'cancelTips': '请阅读并同意账号注销协议',
    //  V1.3.SP3 账号注销结束
    'auth': '身份认证',
    'finish': '修改完成',
    'binding': '绑定完成',
    'verifyType': '验证方式',
    'ChangePhone': '修改手机',
    'ChangeEmail': '修改邮箱',
    'tips1': '恭喜您，您的密码修改成功',
    'tips2': '恭喜您，您的手机修改成功',
    'tips3': '恭喜您，您的邮箱修改成功',
    'tips4': '恭喜您，您的手机绑定成功',
    'tips5': '恭喜您，您的邮箱绑定成功',
    'tips6': '恭喜您，用户名设置成功',
    pleaseFirst: '请先',
    or: '或者'
  },
  'accountConflict': {
    'title': '账户信息确认',
    'desc1': '您好！',
    'desc2': '系统检测到您的邮箱/手机注册过我司多个系统。</br>为了提升体验，请您选择其中一个登录账号作为多个系统的统一登录账号。',
    'desc3': '点击"确认"后，系统将向您的邮箱/手机发送修改密码链接。请根据提示操作并妥善保管。',
    'loginName': '登录名',
    'phone': '手机',
    'registerSys': '注册系统',
    'registerTime': '注册时间',
    'newRegister': '新注册',
    'infoVer': '信息验证',
    'inforVerSelect': '请选择您的验证方式',
    'selectOne': '请您选择其中一个登录账号',
    'IBS': '海外下单发件管理系统',
    'ICAS': 'KEX统一账号管理平台',
    'IUOP': ' KEX统一订单平台',
    'IBSE': 'KEX商家物流出口',
    'PMS': 'KEX商家物流进口',
    'IBSI': 'KEX商家物流进口',
    'SFBUY': '海购丰运',
    'POP': '供应商开放平台',
    'SFGOAPP': 'KEX下单平台',
    'IFTP': 'KEX货运平台',
    'OFTP': '海外货运平台'
  },
  permission: {
    reset: '重置',
    enable: '启用',
    disable: '禁用',
    delete: '删除',
    deleteBatch: '批量删除',
    remark: '备注',
    sort: '排序',
    confirm: '确定',
    cancel: '取消',
    operation: '操作',
    modify: '修改',
    select: '请选择',
    input: '请输入用户名或编号',
    query: '查询',
    edit: '编辑',
    required_rule: '数据不能为空',
    success: '操作成功',
    fail: '操作失败',
    length_rule: '长度在{min}到{max}个字符',
    deleteTip1: '请先禁用 "{name}" 下的所有子系统',
    deleteTis: '是否确认删除名称为 "{name}" 的数据项?',
    deleteChildTis: ' 同时该系统下的所有系统都会被删',
    tis: '提示',
    deleteBatchTis: '确认删除选中的{num}条数据?',
    enableTis: '确认{statusName}选中的{num}条数据?',
    msgError: '操作数据有误',
    codeCheckRule: '允许大小写字母、数字、"_"或"-"',
    checkMinCharacter: '请输入{min}个以上字符',

    // 角色管理
    roleType_0: '自建角色',
    roleType_1: '系统管理员',
    bindResource: '绑定资源',
    roleList: '角色列表',
    roleAdd: '新增角色',
    roleEdit: '编辑角色',
    roleConfig: '配置角色',
    childSystemName: '子系统名称',
    roleNo: '角色编号',
    roleName: '角色名称',
    roleDescribe: '角色描述',
    isSystem: '所属系统',
    roleType: '角色类型',

    // 用户管理
    userStatus_0: '未激活',
    userStatus_1: '已激活',
    userStatus_2: '预注销',
    userStatus_3: '已注销',
    userStatus_4: '禁用',
    userStatus_5: '锁定',
    userRoleEdit: '查看/编辑角色',
    userList: '用户列表',
    regtime: '注册时间',
    userCode: '用户编号',
    area: '所属地区',
    nickName: '昵称',
    sourceSystem: '来源系统',
    userStatus: '状态',

    // 系统管理
    systemList: '系统列表',
    systemAdd: '新增系统',
    systemModify: '修改系统',
    systemName: '系统名称',
    systemType: '系统类型',
    systemType_0: '主数据',
    systemType_1: '业务系统',
    systemCode: '系统编码',
    systemStatus: '系统状态',
    systemStatus_0: '启用',
    systemStatus_1: '禁用',
    systemAddChildren: '新增子系统',
    systemSuperior: '上级系统',

    // 资源管理
    resourceList: '资源列表',
    resourceAdd: '新增资源',
    resourceModify: '修改资源',
    resourceName: '资源名称',
    resourceType: '资源类型',
    resourceType_MENU: '菜单',
    resourceType_MODULE: '目录',
    resourceType_WIDGET: '按钮',
    resourceCode: '资源编码',
    resourceStatus: '资源状态',
    resourceStatus_true: '启用',
    resourceStatus_false: '禁用',
    resourceAddChildren: '新增子项',
    resourceSuperior: '上级菜单',
    icon: '图标样式',
    iconActive: '活动图标',
    shortName: '简称',
    resourceUrl: '资源URL',
    resourceFun: '功能URL',
    openType: '打开方式',
    openType_0: '页面路由',
    openType_1: '新窗口',
    pub: '是否需要权限控制',
    pub_true: '是',
    pub_false: '否',
    hidden: '是否隐藏',
    hidden_0: '是',
    hidden_1: '否',
    selectSystem: '请先选择系统',
  },
  protocol: {
    num: '编号',
    protocolName: '协议名称',
    protocolNo: '协议版本号',
    signTime: '签署时间',
    remark: '备注',
    signUser: '签署账号',
    signName: '签署客户名称',
    signChild: '协议子版本号',

  },
  sfbuy: {
    'wechatScane': '微信扫一扫',
    'wechatScane1': '及时掌握',
    'wechatScane2': '微信动态',
    'onlineService': '在线客服',
    'aboutUs': '关于我们',
    'serviceGuide': '新手指南',
    'helpCenter': '帮助中心',
    'serviceAndPrice': '服务与价格',
    'announcement': '公告',
    'important': '重要'
  },
  weakPassword: {
    提示: '提示',
    账号异常提醒: '您的账号存在异常，请及时修改密码，或者使用验证码、扫码方式登录',
    修改密码: '修改密码',
    关闭: '关闭',
    账号异常处理: '账号异常处理',
    绑定提示: '请先绑定手机或者邮箱，然后进行密码修改',
    账号: '账号'
  },
  twoFactorAuth: {
    双因素认证: '双因素认证',
    认证方式: '认证方式',
    为了您的账号安全: '为了您的账号安全，需完成双因素认证后登录',
    请选择绑定: '请选择绑定:',
    请先设置您的密码: '请先设置您的密码'
  },
  sendType: {
    您当前手机区号不支持whatsapp: '您当前手机区号不支持{noticeChanel}，请选择其他获取验证码方式',
    请使用绑定手机号接收验证码: '请使用绑定手机号接收验证码',
    请使用绑定邮箱接收验证码: '请使用绑定邮箱接收验证码',
    请选择验证码接收方式: '请选择验证码接收方式'
  }
}
